import React, { useState } from "react";
import DatePicker from "react-datepicker";



import styled from "styled-components/macro";



import { useSignupListHasRespondents } from "Signups/SignupView/utils/useSignupListHasRespondents";



import { useGetCurrentSignupList } from "Utilities/Hooks/useGetCurrentSignupList";



import SignupOption, { SignupSubOption } from "../../SignupOption";
import { getBeginningOfToday, getEndOfToday, getNextWeek, getNextYear, isToday } from "../../util";



import ManualReminderButton from "./ManualReminderButton";
import PaymentReminderButton from "./PaymentReminderButton";
import SentRemindersList from "./SentRemindersList";


export default function SignupReminders() {
  const {
    ID: signupListID,
    options: { sendReminderAt, showPaymentRemindersButton },
    signupListStatusID,
  } = useGetCurrentSignupList();

  const [reminderDate, setReminderDate] = useState(
    getInitialReminderDate(sendReminderAt)
  );

  const hasRespondents = useSignupListHasRespondents();

  const isReminderScheduled = Boolean(sendReminderAt);
  const now = new Date();

  // TODO was this really desired: disabled={signupListStatusID !== 1 || sentScheduledReminders.length > 0}
  return (
    <>
      <SignupOption
        text="Automatically remind people about their Signup at a certain time"
        name="sendReminderAt"
        on={isReminderScheduled}
        disabled={signupListStatusID !== 1}
        customValue={reminderDate.getTime() / 1000}
      >
        <SignupSubOption show={isReminderScheduled}>
          <DatePickerWrapper>
            <DatePicker
              selected={reminderDate}
              onChange={setReminderDate}
              showTimeSelect
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="MMMM d, yyyy h:mm aa"
              minDate={now}
              minTime={isToday(reminderDate) ? now : getBeginningOfToday()}
              maxDate={getNextYear()}
              maxTime={getEndOfToday()}
              popperModifiers={{
                offset: {
                  enabled: true,
                  offset: "-78px, 0px",
                },
              }}
            />
          </DatePickerWrapper>
        </SignupSubOption>
      </SignupOption>

      <ReminderButtons>
        {hasRespondents ? (
          <ManualReminderButton signupListID={signupListID} />
        ) : null}

        {showPaymentRemindersButton ? (
          <PaymentReminderButton signupListID={signupListID} />
        ) : null}
      </ReminderButtons>

      <SentRemindersList />
    </>
  );
}

function getInitialReminderDate(sendReminderAtTime) {
  const nextWeek = getNextWeek();
  if (!sendReminderAtTime) return nextWeek;

  const now = new Date();
  const sendReminderAtDate = new Date(sendReminderAtTime * 1000);

  // sendReminderAtTime is stale | this should never happen?
  // just in case, we don't want to confuse Betty
  if (sendReminderAtDate < now) return nextWeek;

  return sendReminderAtDate;
}

const DatePickerWrapper = styled.div`
  .react-datepicker__input-container input {
    width: 200px;
  }
  .react-datepicker__month-container {
    border-right: 1px solid #aeaeae;
  }
  .react-datepicker__time-container {
    border-left: none;
  }
`;

const ReminderButtons = styled.div`
  margin-top: -10px;
  margin: -10px 0 12px 25px;
`;